import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";
import $ from "jquery";

class PopupWindow extends WebComponent {

	constructor(props) {
		super(props);
		const {} = props;
		this.state = {};
	}

	didMount () {
		const {
			cookieName,
		} = this.props;

		this.cookieName = cookieName;

		// #414 - vyskakovaci okno se ma zobrazit max 1x za den v ramci prohlizece.
		// Diky tomu se popup neobjevi znovu po prepnuti profilu (Klient/Prevadzka)
		// ani po prepnuti organizace - oba tyto pripady jen znovu nactou homepage.
		if(this.element.getAttribute('data-once-per-day') === 'true') {
			const today = this.getTodayKey();
			// Pro variantu "jednou a dost (uz nikdy)" staci porovnavat s pevnou
			// hodnotou (napr. "1") misto dnesniho data.
			if(this.getCookie(this.cookieName) !== today) {
				this.openPopup();
				this.setCookie(this.cookieName, today, 400);
			}
			return;
		}

		this.checkCookie();

		if(this.element.getAttribute('data-set-cookie') === 'true') {
			if((this.getCookie(this.cookieName) === "1" || this.getCookie(this.cookieName) === "")) {
				this.openPopup();
				this.setCookie(this.cookieName, 0);
			}
		} else {
			this.openPopup();
		}
		if(this.element.getAttribute('data-esp-class-name') === "esp__target--custom-close") {
			$(document).off('keyup.esp').on('keyup.esp', function (event){
				if (event.which == 27) {
					event.preventDefault();
				}
			});
		}
	}

	openPopup = () => {
		let popupWindowData = document.querySelector("#popupWindowData");
		if(popupWindowData) {
			if(popupWindowData.innerText.length > 0){
				dispatchEvent(this.element, 'click', false);
			}
		} else {
			dispatchEvent(this.element, 'click', false);
		}
	}

	setCookie(cName, cValue, expiresDays) {
		let cookie = cName + "=" + cValue + ";path=/";
		// Bez expirace = session cookie (puvodni chovani pro data-set-cookie).
		// S expiraci cookie prezije restart prohlizece - potreba pro 1x/den (#414).
		if(typeof expiresDays === 'number') {
			cookie += ";max-age=" + (expiresDays * 24 * 60 * 60);
		}
		document.cookie = cookie;
	}

	getTodayKey() {
		const now = new Date();
		const month = ("0" + (now.getMonth() + 1)).slice(-2);
		const day = ("0" + now.getDate()).slice(-2);
		return now.getFullYear() + "-" + month + "-" + day;
	}

	getCookie(cName) {
		var name = cName + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	checkCookie() {
		let name = this.getCookie(this.cookieName);
		if (name === "" && name == null) {
			this.setCookie(this.cookieName, 1);
		}
	}
	willUnMount() {
		this.elements = null;
	}
}

PopupWindow.defaultProps = {
	cookieName: 'showPopUpWindow',
}

export default PopupWindow;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/PopupWindow.js